import { render } from "./searchStudentStats.vue?vue&type=template&id=1698c6e2&scoped=true"
import script from "./searchStudentStats.vue?vue&type=script&lang=js"
export * from "./searchStudentStats.vue?vue&type=script&lang=js"

import "./searchStudentStats.vue?vue&type=style&index=0&id=1698c6e2&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1698c6e2"]])

export default __exports__